import React, { useState } from 'react';
import './App.css';
import ImageSelector from './components/ImageSelector';
import ComparisonView from './components/ComparisonView';
import { containerImages } from './data/containerData';

function App() {
  const [selectedImageId, setSelectedImageId] = useState('python-latest');
  
  const selectedImageData = containerImages.find(img => img.id === selectedImageId);

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <img src="/logo.png" alt="KoalaLab Logo" className="app-logo" />
          <div className="header-text">
            <h1>KoalaLab Container Security Demo</h1>
            <p className="subtitle">Compare hardened container images with DockerHub alternatives</p>
          </div>
        </div>
      </header>
      
      <main className="App-main">
        <ImageSelector 
          images={containerImages}
          selectedImage={selectedImageId}
          onImageSelect={setSelectedImageId}
        />
        
        <ComparisonView imageData={selectedImageData} />
      </main>
    </div>
  );
}

export default App;
